import { useMemo } from 'react'
import { useSetAtom } from 'jotai'

import { authProfileAtom } from '../atoms/auth-profile.atom'

export const useAuthProfileSetter = () => {
    const profileSetter = useSetAtom(useMemo(() => authProfileAtom, []))

    return {
        profileSetter,
    }
}
